// extracted by mini-css-extract-plugin
module.exports = {"root":"Tickaroo_root__6tsET"};